module.exports = __webpack_public_path__ + "img/40_39.ace65859.png";